import React, {Component} from 'react'
import {Card} from '../Card'
import {Title} from '../Title'
import {Grid} from '../Grid'

import './card-grid.css'
const nCellsPerRowMobile = 1;
const nCellsPerRow = 4;

class CardGrid extends Component {

  render() {
    let cards = this.props.data.map(
      (datum, index) =>
        <Card
          height = {this.props.height}
          isShort = {this.props.isShort}
          data={datum} sizes = {this.props.sizes[index]}>
        </Card>
    );

    return (
      <Grid
        data = {cards}
        nCellsPerRow = {nCellsPerRow}
        nCellsPerRowMobile = {nCellsPerRowMobile}
      ></Grid>
    );
  }
}

export default {CardGrid}



// WEBPACK FOOTER //
// ./src/components/CardGrid/index.js